import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, MessageCircle, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const PremiumFooter = () => {
  const handleEmailClick = () => {
    window.location.href = `mailto:RAEVenturesLLC@gmail.com?subject=Beach%20Escape%20FL%20-%20Extended%20Stay%20Inquiry`;
  };

  const handleTextClick = () => {
    window.location.href = `sms:4074509182?body=Hi!%20I'm%20interested%20in%20a%2090%2B%20day%20rental%20at%20Beach%20Escape%20FL.`;
  };

  const handleCallClick = () => {
    window.location.href = `tel:4074509182`;
  };

  return (
    <footer className="bg-[#0A1628] text-white" data-testid="footer">
      {/* CTA Section */}
      <div className="border-b border-white/10">
        <div className="container-premium py-16 md:py-20">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <p className="label-sm text-[#C9A962] mb-4">Ready to Reserve?</p>
              <h3 className="headline-md text-white mb-4">
                Secure Your Extended Stay Today
              </h3>
              <p className="body-md text-white/70">
                Peak season dates fill quickly. Contact us for availability and personalized monthly rates.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-4 md:justify-end">
              <Link to="/contact">
                <Button className="bg-[#C9A962] text-[#0A1628] hover:bg-[#B8954D] rounded-none px-8 py-6 text-base font-medium w-full sm:w-auto">
                  Request Quote
                  <ArrowRight className="w-4 h-4 ml-2" />
                </Button>
              </Link>
              <Button 
                onClick={handleCallClick}
                className="bg-transparent border border-white/30 text-white hover:bg-white/10 rounded-none px-8 py-6 text-base font-medium"
              >
                <Phone className="w-4 h-4 mr-2" />
                Call Now
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="container-premium py-16">
        <div className="grid md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <h4 className="font-display text-2xl font-medium mb-4">Beach Escape</h4>
            <p className="text-sm text-white/60 leading-relaxed mb-6">
              Premium furnished housing for extended stays in Indialantic, Florida. 
              90-day minimum. Corporate, seasonal, and relocation housing.
            </p>
            <div className="flex items-start gap-2 text-white/60 text-sm">
              <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
              <span>2161 Todd Ln<br />Indialantic, FL 32903</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h5 className="font-body font-semibold text-sm uppercase tracking-wider mb-6">Housing Types</h5>
            <nav className="flex flex-col gap-3">
              <Link to="/monthly-rates" className="text-white/60 hover:text-[#C9A962] transition-colors text-sm">Monthly Rates</Link>
              <Link to="/corporate-housing" className="text-white/60 hover:text-[#C9A962] transition-colors text-sm">Corporate Housing</Link>
              <Link to="/snowbird-rentals" className="text-white/60 hover:text-[#C9A962] transition-colors text-sm">Snowbird Rentals</Link>
              <Link to="/traveling-nurse-housing" className="text-white/60 hover:text-[#C9A962] transition-colors text-sm">Travel Nurse Housing</Link>
            </nav>
          </div>

          {/* Areas We Serve — internal linking for local SEO */}
          <div>
            <h5 className="font-body font-semibold text-sm uppercase tracking-wider mb-6">Areas We Serve</h5>
            <nav className="flex flex-col gap-3">
              <Link to="/indialantic-beach-rental" className="text-white/60 hover:text-[#C9A962] transition-colors text-sm">Indialantic Beach Rental</Link>
              <Link to="/melbourne-beach-house-rental" className="text-white/60 hover:text-[#C9A962] transition-colors text-sm">Melbourne Beach House Rental</Link>
              <Link to="/satellite-beach-rental" className="text-white/60 hover:text-[#C9A962] transition-colors text-sm">Satellite Beach Rental</Link>
              <Link to="/space-coast-monthly-rental" className="text-white/60 hover:text-[#C9A962] transition-colors text-sm">Space Coast Monthly Rental</Link>
              <Link to="/brevard-county-furnished-rental" className="text-white/60 hover:text-[#C9A962] transition-colors text-sm">Brevard County Furnished Rental</Link>
              <Link to="/gallery" className="text-white/60 hover:text-[#C9A962] transition-colors text-sm">Photo Gallery</Link>
              <Link to="/faq" className="text-white/60 hover:text-[#C9A962] transition-colors text-sm">FAQ</Link>
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h5 className="font-body font-semibold text-sm uppercase tracking-wider mb-6">Contact Direct</h5>
            <div className="flex flex-col gap-4">
              <button 
                onClick={handleCallClick}
                className="flex items-center gap-3 text-white/60 hover:text-[#C9A962] transition-colors text-sm text-left"
              >
                <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center">
                  <Phone className="w-4 h-4 text-[#C9A962]" />
                </div>
                <div>
                  <span className="block text-white font-medium">Call Us</span>
                  <span>(407) 450-9182</span>
                </div>
              </button>
              <button 
                onClick={handleTextClick}
                className="flex items-center gap-3 text-white/60 hover:text-[#C9A962] transition-colors text-sm text-left"
              >
                <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center">
                  <MessageCircle className="w-4 h-4 text-[#C9A962]" />
                </div>
                <div>
                  <span className="block text-white font-medium">Text Us</span>
                  <span>(407) 450-9182</span>
                </div>
              </button>
              <button 
                onClick={handleEmailClick}
                className="flex items-center gap-3 text-white/60 hover:text-[#C9A962] transition-colors text-sm text-left"
              >
                <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center">
                  <Mail className="w-4 h-4 text-[#C9A962]" />
                </div>
                <div>
                  <span className="block text-white font-medium">Email</span>
                  <span className="text-xs">RAEVenturesLLC@gmail.com</span>
                </div>
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/40 text-sm">
            © {new Date().getFullYear()} Beach Escape FL. All rights reserved.
          </p>
          <p className="text-white/40 text-sm">
            90-Day Minimum · Direct Owner Booking · Professionally Managed
          </p>
        </div>
      </div>
    </footer>
  );
};

export default PremiumFooter;
